export default __webpack_public_path__ + "static/media/close-light-icon.623960b3.svg";